export default "__VITE_ASSET__B7aM8Kzf__"